<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
    title="打印预览"
    :visible="visible"
    width="900px"
    :before-close="hideDialog"
    :close-on-click-modal="false"
  >
    <div id="surePricePrint">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContract"
        style="margin: 10px 0"
        >打印
      </el-button>
      <div
        ref="bidOrderPrint"
        id="bidOrderPrint"
        style="font-size: 16px; font-family: 宋体"
      >
        <div style="text-align: center; font-size: 30px; padding: 30px 0 20px">
          {{ formData.title }}
        </div>
        <div style="text-align: center; font-size: 20px"></div>
        <div style="font-size: 18px; padding-bottom: 10px">
          <div
            contenteditable="true"
            style="display: inline-block; float: right"
          >
            时间：{{ formatDate(formData.approveTime) }}
          </div>
        </div>
        <div style="border: 1px solid rgb(0, 0, 0); margin: 20px 0">
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 56px;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              提报单位
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.commitDeptName }}
            </div>
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                border-left: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              项目名称
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.projectName }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 56px;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              提报单位负责人
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.commitResponseUserName }}
            </div>
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                border-left: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              经办人
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.handlingUserName }}
            </div>
          </div>

          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              min-height: 140px;
              padding: 4px;
            "
          >
            <div>项目情况：</div>
            <div style="margin: 20px; text-indent: 20px">
              {{ formData.projectState }}
            </div>
          </div>

         
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              min-height: 62px;
              page-break-inside: avoid;
              padding: 4px;
            "
            v-if="formData.options2&&formData.options2.length>0"
          >
            <div>{{printData.typeOptions[1].value||'试验检测中心意见'}}（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options2"
                :key="index"
                style="
                  margin: 6px 20px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>
          <div
          v-if="formData.options4&&formData.options4.length>0"
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              min-height: 76px;
              page-break-inside: avoid;
              padding: 4px;
            "
          >
            <div>{{printData.typeOptions[3].value||'安全管理部意见'}}（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options4"
                :key="index"
                style="
                  margin: 6px 20px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="80px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              min-height: 60px;
              padding: 4px;
            "
          >
            <div v-if="printData.typeOptions[0]">{{printData.typeOptions[0].value}}（同意、附条件同意或不同意）：</div>
            <div v-else>市场开发部意见（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options1"
                :key="index"
                style="
                  margin: 6px 20px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              min-height: 76px;
              page-break-inside: avoid;
              padding: 4px;
            "
          >
            <div v-if="printData.typeOptions[2]">{{printData.typeOptions[2].value}}（同意、附条件同意或不同意）：</div>
            <div v-else>工程管理部意见（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options3"
                :key="index"
                style="
                  margin: 6px 20px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>
          
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              min-height: 90px;
              page-break-inside: avoid;
              padding: 4px;
            "
          >
            <div v-if="printData.typeOptions[4]">{{printData.typeOptions[4].value}}（同意、附条件同意或不同意）：</div>
            <div v-else>财务管理部意见（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options5"
                :key="index"
                style="
                  margin: 10px 20px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.opinion">{{ item.opinion }}。 </div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="110px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              min-height: 80px;
              page-break-inside: avoid;
              padding: 4px;
            "
          >
            <div v-if="printData.typeOptions[5]">{{printData.typeOptions[5].value}}（同意、附条件同意或不同意）：</div>
            <div v-else>委员会委员意见（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options6"
                :key="index"
                style="
                  margin: 10px 20px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>
          <div
            style="min-height: 110px; page-break-inside: avoid; padding: 4px"
          >
            <div v-if="printData.typeOptions[6]">{{printData.typeOptions[6].value}}（同意、附条件同意或不同意）：</div>
            <div v-else>委员会主任意见（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options7"
                :key="index"
                style="
                  margin: 12px 20px 0;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="130px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="bidOrderPrintContent"
          class="mainHtml"
          id="printbidOrderPrintContent"
        ></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import printJS from "print-js";

export default {
  name: "surePricePrint",
  props: {
    printData: {
      type: Object,
    },
    visible: {
      type: Boolean,
      defaule: false,
    },
  },
  data() {
    return {
      approveProcessList: [],
      bidOrderPrintContent: null,
    };
  },
  computed: {
    formData() {
      const filterApproveInfoList = this.printData.approveInfoList.filter(
        (i) => i.isPrint
      );
      const options1 = filterApproveInfoList.filter(
        (i) => i.opinionKey == 'costDept'//"市场开发部意见"
      );
      const options2 = filterApproveInfoList.filter(
        (i) => i.opinionKey == "equiptmentDept"  //试验检验中心意见
      );
      const options3 = filterApproveInfoList.filter(
        (i) => i.opinionKey == "businessDept" //工程管理部意见
      );
      const options4 = filterApproveInfoList.filter(
        (i) => i.opinionKey == "auditDept"  //安全管理部意见
      );
      const options5 = filterApproveInfoList.filter(
        (i) => i.opinionKey == "safeandProject"  //财务管理部意见
      );
      const options6 = filterApproveInfoList.filter(
        (i) => i.opinionKey =='bidCommitteeDept' //"委员会委员意见"
      );
      const options7 = filterApproveInfoList.filter(
        (i) => i.opinionKey == 'superDept' //"委员会主任意见"
      );
console.log('-----------------this.printData')
console.log(this.printData)
      return {
        ...this.printData,
        options1,
        options2,
        options3,
        options4,
        options5,
        options6,
        options7,
      };
    },
  },

  mounted() {
    // try {
    //   this.bidOrderPrintContent = this.$refs.bidOrderPrint.innerHTML;
    //   this.bidOrderPrintContent =
    //     document.getElementById("bidOrderPrint").innerHTML;
    // } catch (err) {
    //   console.log(err);
    // }
  },
  methods: {
    hideDialog() {
      this.$emit("update:visible", false);
    },
    //打印当前合同
    PrintContract() {
      this.$set(
        this,
        "bidOrderPrintContent",
        this.$refs.bidOrderPrint.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printbidOrderPrintContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
        });
      });
    },
    formatDate(dateStr) {
      let date = new Date(dateStr);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },
  },
};
</script>
<style lang="scss">
#bidOrderPrint {
  box-shadow: 0px 4px 12px 2px #bbb;
  position: relative;
  padding: 0 10px;
  width: 21cm;
  margin: 0 auto;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
